<template>
  <multiple-select
    v-model:value="multipleValue"
    :placeholder="placeholder"
    :list="multipleList"
    :maxTagTextLength="maxTagTextLength"
    :maxTagCount="maxTagCount"
    :class-name="className"
  >
  </multiple-select>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, PropType, computed } from "vue";
import {
  ProfileSimpleListReq,
  ProfileSimpleRecord,
} from "@/views/project/profile/profile.interface";
import MultipleSelect from "./multiple-select/index.vue";
import { ProfileService } from "@/views/project/profile/profile.service";
interface MultipleValueType {
  value: string;
  label: string;
}

/**
 * 项目选择器
 *
 * 使用方式:
 * <project-select v-model:value="formRef.projectId"></project-select>
 */
export default defineComponent({
  isGlobal: true,
  name: "MultipleProjectSelect",
  components: {
    MultipleSelect,
  },
  props: {
    value: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    externalData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },

    placeholder: {
      type: String,
      default: "请选择",
    },

    // 其他状态
    // 技术方案: skillSolutionValidStatus
    // 招标申请: bidValidStatus
    // 招标文件购买申请: bidFileApplyValidStatus
    // 保证金申请: assuringMoneyApplyProcessStatus
    // 招标报价: bidOfferValidStatus
    /**
     * 可能后续不会用到
     */
    otherStatus: {
      type: Array,
      default: () => [],
    },

    // 项目状态, 从字典中获取, 字典值: project_status
    projectStatus: {
      type: Array,
      default: () => [],
    },
    flowStatus: {
      type: Array,
      default: () => [],
    },
    api: {
      type: String,
    },
    defaultItem: {
      type: Array as PropType<ProfileSimpleRecord[]>,
      default: () => [],
    },
    req: {
      type: Object,
      default: () => {},
    },
    isBackName: {
      type: Boolean,
      default: false,
    },
    maxTagCount: {
      type: Number,
      default: null,
    },
    maxTagTextLength: {
      type: Number,
      default: null,
    },
    className: {
      type: String,
      default: "",
    },
  },
  emits: ["update:value", "change"],
  setup(props, { emit }) {
    let { data: records, run, loading } = ProfileService.useSimpleListApi();
    const onChange = async (id) => {
      emit("update:value", id);
      if (props.isBackName && id) {
        let select = records?.value.find((v) => (v as any).id == id);
        emit("change", select);
      } else {
        emit("change", id);
      }
    };

    onMounted(async () => {
      const req = new ProfileSimpleListReq();
      req.merge({
        projectStatus: props.projectStatus,
        otherStatus: props.otherStatus,
        flowStatus: props.flowStatus,
        status: props.projectStatus,
      });
      req.merge(props.req);
      await run(req, props.api);
      let array: any = JSON.parse(JSON.stringify(records.value));
      props.defaultItem.forEach((item) => {
        if (!array.find((value) => value.id == item.id)) {
          array.push(item);
        }
      });
      //编辑技术方案时，回显使用
      if (props.externalData.projectId && props.externalData.projectName) {
        array.push({ id: props.externalData.projectId, name: props.externalData.projectName });
      }
      records.value = array;
    });

    const multipleValue = computed({
      get() {
        if (props.value?.length) {
          return records.value?.reduce<MultipleValueType[]>((total, ele:any) => {
            if (props.value.includes(ele.id)) {
              total.push({ value: ele.id, label: ele.name });
            }
            return total;
          }, []);
        }

        return [];
      },
      set(val: MultipleValueType[]) {
        emit(
          "update:value",
          val.map((ele) => ele.value)
        );
      },
    });

    const multipleList = computed(() => {
      return records.value?.map((ele) => ({ value: ele.id, label: ele.name }));
    });

    return {
      records,
      loading,
      onChange,
      multipleValue,
      multipleList,
    };
  },
});
</script>
